import axios from 'axios';
import config from '@/utils/config';
import app from '../main';

const axiosInstance = axios.create({
  baseURL: config.API_URL,
});

axiosInstance.interceptors.response.use(
  async (response) => response,
  async (error) => {
    if (error.response?.status === 503 && app.$route.name !== 'Auth') {
      app.$router.push('/auth');
      return error;
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
